module.exports = __webpack_public_path__ + "img/center02.03a0cc48.webp";